import type { CaseDetail } from '@/mocks/portfolio';

const chefsPrideCase: CaseDetail = {
  id: 'chefs-pride',
  project: "CHEF'S CRAFT",
  client: 'Food Brand',
  year: 'Archive',
  category: 'Branding / Product',
  role: 'Brand Strategy / Product Branding / Promotion',
  issue: 'プロ向け食品としての品質強みがある一方、一般の生活者にはその価値が十分に伝わっていなかった。',
  challenge: '「プロの現場が認める品質」を、家庭ユーザーにも信頼できるブランドとして伝えること。',
  insight: '「プロ御用達」という事実そのものが、品質の証明として最も強いメッセージになる。',
  strategy: 'シェフの「誇り」を軸にしたブランドコンセプトを設計。プロの信頼と家庭の価値を結ぶ。',
  experience: 'パッケージ・店頭・プロモーションを通じて、品質の信頼感を一貫して表現。',
  output: 'Brand Concept / Logo / VI / Package / Promotion',
  impact: 'プロユースの品質価値を家庭へ伝え、カテゴリ内での差別化を確立。',
  images: [
    {
      src: '/assets/migrated/65417f7820afe7e51e5e.webp',
      caption: "新商品スウィーツブランド CHEF'S CRAFT — ロゴタイプ・シンボルマーク・ブランドカラー総合案",
    },
    {
      src: '/assets/migrated/b951a50cd667eeff1bfe.webp',
      caption: "CHEF'S PRIDE ブランドコンセプト — Chef Hat + Pride + Friendly = CHEF'S PRIDE",
    },
    {
      src: '/assets/migrated/2ac1ba80e0363559acec.webp',
      caption: "CHEF'S PRIDE ロゴマーク — シェフ帽アイコン化、プレミアム感・重厚感のコミュニケーション",
    },
    {
      src: '/assets/migrated/a27526ffe7403fd34ba3.webp',
      caption: "CHEF'S PRIDE ブランドポスター② — 一流シェフこだわりのプレミアムスイーツ（キービジュアル・手描き食材フレーム）",
    },
    {
      src: '/assets/migrated/7ab089b11a2ed0966a38.webp',
      caption: "とろもち手作りわらび餅 ラベル — CHEF'S CRAFT シェフ監修、本わらび粉使用（寸法図付き）",
    },
    {
      src: '/assets/migrated/01d20f3555a2b8f51122.webp',
      caption: "CHEF'S PRIDE ラベルデザイン — なめらかプリン・手作りわらび餅・ピザ用シール（透明フィルム＋ブランドカラー）",
    },
    {
      src: '/assets/migrated/600bdf16095bef5ec11f.webp',
      caption: "濃厚なめらかプリン ラベル — CHEF'S CRAFT シェフ監修、店内手作り、厳選した卵と牛乳を使用（寸法図付き）",
    },
    {
      src: '/assets/migrated/e10381c004e92bf78f8c.webp',
      caption: "ラベル ピザ φ60mm — CHEF'S CRAFT シェフ監修、ピザ実物展開（page 9）",
    },
    {
      src: '/assets/migrated/b915bd5d84201789eaf0.webp',
      caption: "CHEF'S PRIDE + CHEF'S CRAFT ロゴ構成 — CHEF'S PRIDEロゴタイプとCHEF'S CRAFTシンボルマーク（黒/白抜き2パターン）",
    },
    {
      src: '/assets/migrated/0532a9dd67620b77dbfa.webp',
      caption: 'コトPOP（近景ツール）page 29 — なめらかプリン・手作りわらび餅・アップルカスタードピザの商品こだわり説明POP',
    },
    {
      src: '/assets/migrated/2567c00f7fd556ea575b.webp',
      caption: 'ブランドポスター①（別案/コピー配置構成）page 26 — 一流シェフこだわりのプレミアムスイーツ（縦型・横型バリエーション）',
    },
    {
      src: '/assets/migrated/407155d5ea6f437918c1.webp',
      caption: "ブランドロゴ設計 page 15 — CHEF'S PRIDE ロゴマーク（黒背景大・シェフハットビジュアル化、プレミアム感・重厚感）",
    },
    {
      src: '/assets/migrated/db87b159ab40e071c326.webp',
      caption: 'シェフのこだわりポスター page 28 — シェフのこだわりでブランド商品のこだわりを見せる（A1サイズ・シェフ写真付き）',
    },
    {
      src: '/assets/migrated/fcad023ef22762af69ff.webp',
      caption: 'ブランドポスター① page 25 — 一流シェフこだわりのプレミアムスイーツ（キービジュアル・縦型・横型レイアウト）',
    },
    {
      src: '/assets/migrated/431c8d413b4266cf69bc.webp',
      caption: '店頭ポスター展開設置イメージ page 32-35 — なめらかプリン冷ケース・わらび餅・オリジナルピザの横組/縦組ポスター展開',
    },
    {
      src: '/assets/migrated/276a563fa9f335675652.webp',
      caption: "CHEF'S CRAFT ブランドコンセプト — 新商品スウィーツブランドの理念と Chef Hat + Pride + Friendly = CHEF'S PRIDE",
    },
    {
      src: '/assets/migrated/19dfd4df2d6531672988.webp',
      caption: "とろもち手作りわらび餅 ラベル page 8 — CHEF'S CRAFT シェフ監修、本わらび粉使用（寸法図・展開仕様付き）",
    },
    {
      src: '/assets/migrated/001f2e8de0a77b75933d.webp',
      caption: "CHEF'S CRAFT ロゴ構成 — ロゴタイプ・シンボルマーク・ブランドカラーの黒/白抜きバリエーション",
    },
    {
      src: '/assets/migrated/92f964cfba66dded4c67.webp',
      caption: "風味豊かなバニラプリン ラベル page 6 — CHEF'S CRAFT シェフ監修、店内手作り（寸法図・展開仕様付き）",
    },
    {
      src: '/assets/migrated/12923bf0dbb40deeca1e.webp',
      caption: 'ブランドポスター page 3 — 一流シェフこだわりのプレミアムスイーツ（縦型・横型レイアウトバリエーション）',
    },
    {
      src: '/assets/migrated/36fde54ee8d1a2d1bc41.webp',
      caption: "ブランドロゴ 商品ラベル貼付イメージ page 23 — CHEF'S PRIDE ピザ上面ラベル貼付実写",
    },
    {
      src: '/assets/migrated/90447a6f2f35534bce02.webp',
      caption: 'ブランディング設計とクリエーティブ方向性 page 12 — 新商品スウィーツブランドの拡販と確立、LOOK展開とシェフ監修のプレミアム感実現',
    },
  ],
};

export default chefsPrideCase;